import SectionHead from "./SectionHead";
import PersonalDialogueRow from "./PersonalDialogueRow";
import { SECTION_COPY } from "../copy";
import plusIcon from "../../../Assets/icon/explore/plus.svg";

/**
 * PERSONAL_DIALOGUES (Figma 9154:8266) — the member's own Dialogues, made from
 * a recording, document, photo or text (DCI). Cards are UniversalDialogueCards
 * whose `dialogue_id` is an ObjectId rather than a slug; the Overview route
 * takes both, so they open the Detail like any other card.
 *
 * "Capture Something New" opens the Capture tab, where new ones are made.
 */
function PersonalDialoguesSection({ section, onOpenDialogue, onSeeAll, onCapture }) {
  const items = (section?.items || []).filter((item) => item?.dialogue_id);
  if (items.length === 0) return null;

  const c = SECTION_COPY.PERSONAL_DIALOGUES;

  return (
    <section className="ex-section">
      <SectionHead title={c.title} subtitle={c.subtitle} />
      <div className="ex-plist">
        <div className="ex-plist__head">
          <span className="ex-plist__label">{c.library}</span>
          {onSeeAll && (
            <button type="button" className="ex-plist__link" onClick={onSeeAll}>
              {c.seeAll}
            </button>
          )}
        </div>
        {items.map((item) => (
          <PersonalDialogueRow key={item.dialogue_id} item={item} onOpen={onOpenDialogue} />
        ))}
        {onCapture && (
          <div className="ex-plist__foot">
            <button type="button" className="ex-plist__capture" onClick={onCapture}>
              <img src={plusIcon} alt="" width="20" height="20" />
              {c.capture}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default PersonalDialoguesSection;
